import { AffiliateRankingListData } from '@/@types/AffiliateReport';
import AffiliateRankingList from './AffiliateRankingList';

interface Props {
  rankings: AffiliateRankingListData[];
  isLoading: boolean;
  labels: {
    revenue: string;
    aov: string;
    profit: string;
  };
}

export default function AffiliateRankingsSection({
  rankings,
  isLoading,
  labels,
}: Props) {
  const byKey = Object.fromEntries(rankings.map((r) => [r.key, r]));

  const fallback = (key: string): AffiliateRankingListData =>
    byKey[key] ?? { key, title: '', entries: [], emptyMessage: rankings[0]?.emptyMessage ?? '' };

  return (
    <section className="flex flex-col gap-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <AffiliateRankingList
          ranking={fallback('revenue')}
          isLoading={isLoading}
          valueLabel={labels.revenue}
        />
        <AffiliateRankingList
          ranking={fallback('aov')}
          isLoading={isLoading}
          valueLabel={labels.aov}
        />
        <AffiliateRankingList
          ranking={fallback('profit')}
          isLoading={isLoading}
          valueLabel={labels.profit}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <AffiliateRankingList
          ranking={fallback('refund')}
          isLoading={isLoading}
        />
        <AffiliateRankingList
          ranking={fallback('chargeback')}
          isLoading={isLoading}
        />
      </div>
    </section>
  );
}
